// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"LoadingSpinner_loaderContainer__1Dz2L"};